<div class="main-container" *ngIf="(learnspace | async) as ls"
  cdkDropList [cdkDropListData]="ls.courses" (cdkDropListDropped)="drop($event)">
  <ng-container *ngFor="let course of ls.courses">
    <div class="list-item" cdkDrag>
      <simulation-list-item
        [course]="course"
        [canCreateCourse]="canCreateCourse" 
        [learnspaceList]="learnspaceList"
        (listChange)="onListChange($event)"
      ></simulation-list-item>
      <!-- The cdkDragHandle is not detected if it's added inside of the component simulation-list-item. -->
      <!-- So we add a transparent cdkDragHandle here. -->
      <div class="drag-handle" cdkDragHandle></div>
    </div>
  </ng-container>
</div>